<template>
  <tr v-if="!item.deleted">
    <td
      v-if="isColumnDisplayed('product')"
    >
      <product-selector
        ref="product-selector"
        :disabled="isElementDisabled('product') || !!item.product.id"
        :default-product="item.product"
        :available-products="availableProducts"
        @change="onProductChange"
      />
      <stock
        v-if="item.product && item.product.id && isProductSelectFromStock"
        :product-id="item.product && item.product.id"
        :storage-id="storageId"
      />
    </td>
    <td
      v-if="isColumnDisplayed('productPackType')"
    >
      <pack-type-selector
        :disabled="!item.product || !item.product.name || isElementDisabled('pack')"
        :available-pack-types="packTypes || item.product.pack_types"
        :default-pack-type="item.product_pack_type"
        :pack-type-name="item.pack_type_name"
        :is-product-select-from-stock="isProductSelectFromStock"
        @change="onPackTypeChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('supplierSelector')"
    >
      <supplier
        :available-suppliers="computedAvailableSuppliers"
        :auto-select-stock="autoSelectStock"
        :default-supplier="computedDefaultSupplier"
        :disabled="(!item.product || !item.product.name || isElementDisabled('supplierSelector')) && !!item.id"
        :valid="fieldsValidation.supplier"
        :pack-type-name="item.pack_type_name"
        :is-product-select-from-stock="isProductSelectFromStock"
        @change="onSupplierChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('expirationDate')"
    >
      <expiration-date
        :disabled="!item.product || !item.product.name || isElementDisabled('expirationDate')"
        :available-expiration-dates="availableExpirationDates"
        :pack-type="item.product_pack_type"
        :expiration-date="item.expiration_date"
        :valid="fieldsValidation.expirationDate"
        @change="onExpirationDateChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('expirationDateSelector')"
      v-loading="expirationLoading"
    >
      <expiration-date-selector
        :disabled="!expirationDates || !item.product || !item.product.name || isElementDisabled('expirationDateSelector')"
        :auto-select-stock="autoSelectStock"
        :available-expiration-dates="availableExpirationDates"
        :default-expiration-date="item.expiration_date"
        :pack-type-name="item.pack_type_name"
        @change="onExpirationDateChange"
      />
      <el-button
        v-if="expirationDatesFetchFailed && isProductSelectFromStock"
        size="small"
        @click="fetchStock"
      >
        Szavidők betöltése
      </el-button>
    </td>
    <td
      v-if="isColumnDisplayed('count')"
    >
      <count
        :count="item.count"
        :item="item"
        :min-count="minCount"
        :disabled="!item.product || !item.product.name || isElementDisabled('count')"
        :compare-items="compareItems"
        :compare-type="compareType"
        :show-row-warning="showRowWarning"
        @change="onCountChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('remainingCount')"
    >
      <remaining-count
        :remaining-count="item.remaining_count"
        :count="item.count"
      />
    </td>
    <td
      v-if="isColumnDisplayed('baseCount')"
    >
      <base-count
        v-loading="baseCountLoading"
        :item-base-count="item.base_count"
      />
    </td>
    <td
      v-if="isColumnDisplayed('comment')"
    >
      <comment
        :item-comment="item.comment"
        :disabled="!item.product || !item.product.name || !item.expiration_date || isElementDisabled('comment')"
        @change="onCommentChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('invoiceItemComment')"
    >
      <comment
        :item-comment="item.comment"
        :disabled="!item.product || !item.product.name || isElementDisabled('invoiceItemComment')"
        @change="onCommentChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('unitPrice')"
    >
      <unit-price
        :unit-price="item.unit_price"
        :custom-price="customPrice"
        :currency="currency"
        :disabled="!item.product || !item.product.name || isElementDisabled('unitPrice')"
        @change="onUnitPriceChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('purchaseUnitPrice')"
    >
      <unit-price
        :unit-price="item.purchase_unit_price"
        :currency="currency"
        :disabled="!item.product || !item.product.name || isElementDisabled('purchaseUnitPrice')"
        @change="onPurchaseUnitPriceChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('netPrice')"
    >
      <net-price
        :net-price="item.net_price"
        :currency="currency"
        :disabled="!item.product || !item.product.name || isElementDisabled('netPrice')"
        @change="onNetPriceChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('vat')"
    >
      <vat-selector
        :vat="item.vat"
        :disabled="!item.product || !item.product.name || isElementDisabled('vat') || isVatZero"
        @change="onVatChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('declutterReason')"
    >
      <declutter-reason
        :declutter-reason="item.declutter_reason"
        :disabled="!item.product || !item.product.name || isElementDisabled('declutterReason')"
        @change="onDeclutterReasonChange"
      />
    </td>
    <td
      v-if="isColumnDisplayed('actions')"
      style="text-align: right;"
    >
      <actions
        :disabled="isElementDisabled('deleteButton')"
        @delete="onRowDelete"
      />
    </td>
  </tr>
</template>
<script>
import ProductSelector from './columns/ProductSelector';
import PackTypeSelector from './columns/PackTypeSelector';
import ExpirationDateSelector from './columns/ExpirationDateSelector';
import ExpirationDate from './columns/ExpirationDate';
import Supplier from './columns/Supplier';
import Count from './columns/Count';
import RemainingCount from './columns/RemainingCount';
import UnitPrice from './columns/UnitPrice';
import PurchaseUnitPrice from './columns/PurchaseUnitPrice';
import NetPrice from './columns/NetPrice';
import VatSelector from './columns/VatSelector';
import DeclutterReason from './columns/DeclutterReason';
import Actions from './columns/Actions';
import Stock from './Stock';
import BaseCount from './columns/BaseCount';
import Comment from './columns/Comment';
import numberFormatter from './../../../services/NumberFormatter'

export default {
  components: {
    ProductSelector,
    PackTypeSelector,
    ExpirationDate,
    ExpirationDateSelector,
    Supplier,
    Count,
    RemainingCount,
    UnitPrice,
    PurchaseUnitPrice,
    NetPrice,
    VatSelector,
    DeclutterReason,
    Actions,
    Stock,
    BaseCount,
    Comment,
  },
  props: {
    customPrices: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
    defaultItem: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
    minCount: {
      type: Number,
      default() {
        return 1;
      },
      required: false,
    },
    autoSelectStock: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    currency: {
      type: String,
      default() {
        return 'HUF';
      },
      required: false,
    },
    defaultSupplier: {
      type: Object,
      default() {
        return null;
      },
      required: false,
    },
    enabledElements: {
      type: Array,
      default() {
        return ['addButton', 'deleteButton', 'product', 'pack', 'count', 'netPrice', 'vat', 'unitPrice', 'expirationDate', 'expirationDateSelector', 'supplierSelector'];
      },
      required: false,
    },
    roundNet: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    enabledColumns: {
      type: Array,
      default() {
        return ['product', 'productPackType', 'expirationDate', 'supplierSelector', 'count', 'unitPrice', 'netPrice', 'vat', 'actions'];
      },
      required: false,
    },
    priceType: {
      type: String,
      default() {
        return 'purchase_price';
      },
      required: false,
    },
    compareItems: {
      type: Array,
      default() {
        return null;
      },
      required: false,
    },
    compareType: {
      type: String,
      default() {
        return 'diff';
      },
      required: false,
    },
    isVatZero: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    displayAddFreeWordItem: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    isProductSelectFromStock: {
      type: Boolean,
      default() {
        return true;
      },
      required: false,
    },
    availableProducts: {
      validator: prop => typeof prop === 'object' || prop === null,
      default() {
        return null;
      },
      required: false,
    },
    loadBaseCountFromStock: {
      type: Boolean,
      default() {
        return true;
      },
      required: false,
    },
    storageId: {
      type: Number,
      default() {
        return 9;
      }
    },
    showRowWarning: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
  },
  data() {
    return {
      baseCountLoading: false,
      availableSuppliers: null,
      customPrice: null,
      availableExpirationDates: [],
      item: {
        product: {},
        count: 1,
        unit_price: 0,
        purchase_unit_price: 0,
        net_price: 0,
        expiration_date: '',
        supplier_id: null,
        supplier: {},
        base_count: 0,
        comment: '',
      },
      expirationDates: [],
      expirationLoading: false,
      expirationDatesFetchFailed: false,
      packTypes: null,
      stockLoading: false,
      stockFetchFailed: false,
      fieldsValidation: {
        supplier: true,
        expirationDate: true,
      },
      palletDefaultSupplier: null
    };
  },
  computed: {
    computedDefaultSupplier() {
      return (
        this.availableSuppliers
        && this.availableSuppliers.find(supp => supp.id === (this.item.supplier && this.item.supplier.id))
      )
      || (
        this.item.product.suppliers
        && this.item.product.suppliers.find(supp => supp.id === (this.item.supplier_id))
        || (!this.item.is_pallet && this.defaultSupplier)
        || (
          this.item.product.suppliers
          && this.item.product.suppliers.find(supp => supp.id === (this.palletDefaultSupplier))
        )
      )
      || (this.item.supplier && this.item.supplier.id && (
        this.item.supplier.company
          ? this.item.supplier
          : { id: this.item.supplier.id, company: { name: this.item.supplier.name } }
      ))
    },
    computedAvailableSuppliers() {
      if (this.availableSuppliers && this.availableSuppliers.length) {
        return this.availableSuppliers;
      }
      if (this.item.product.suppliers && this.item.product.suppliers.length) {
        return this.item.product.suppliers;
      }
      if (this.computedDefaultSupplier) {
        return [this.computedDefaultSupplier];
      }
      return [];
    }
  },
  beforeMount() {
    this.item = JSON.parse(JSON.stringify(this.defaultItem));
  },
  async mounted() {
    this.palletDefaultSupplier = this.$store.getters['product/palletDefaultSupplier']
    if (this.item.product && this.item.product.name && this.isProductSelectFromStock) {
      await this.fetchStock();
    }
  },
  methods: {
    async fetchStock() {
      this.stockLoading = true;
      try {
        this.packTypes = (await axios.get(`api/products/${this.item.product.id}/storage/${this.storageId}`)).packs;
        this.stockFetchFailed = false;
      } catch (e) {
        this.stockFetchFailed = true;
      }
      this.stockLoading = false;
    },
    onPackTypeChange(packType) {
      this.$set(this.item, 'product_pack_type', packType);
      this.$set(this.item, 'pack_type_name', packType.count_per_pack === 1 ? 'db' : (packType.pack_type && packType.pack_type.name || 'db'));
      this.setNetPrice();
      this.availableSuppliers = packType.suppliers;
    },
    async onProductChange(product) {
      this.item.product = product;

      if (!this.packTypes && !this.item.product.pack_types && product.hasOwnProperty('id')) {
        this.packTypes = await this.$store.dispatch('product/getPackTypes', product.id);
      }

      this.item.is_pallet = product.is_pallet;
      this.item.supplier = this.item.supplier ? this.item.supplier : {}
      if (product.is_pallet === true) {
        this.item.supplier_id = this.item.supplier_id === null ? this.$store.getters['product/palletDefaultSupplier'] : this.item.supplier_id
        this.item.supplier.id = typeof this.item.supplier != 'undefined' && this.item.supplier.id !== null ? this.item.supplier.id : this.$store.getters['product/palletDefaultSupplier']
        this.item.expiration_date = this.item.expiration_date === null || typeof this.item.expiration_date == 'undefined' ? this.$store.getters['product/palletDefaultExpirationDate'] : this.item.expiration_date
      }
      if (this.item.vat === null || this.item.vat === undefined) {
        this.$set(this.item, 'vat', product.vat && product.vat.value || null);
      }
      if (!this.item.unit_price) {
        const customPrice = this.customPrices.find(price => price.product_id === (this.item.product && this.item.product.id));
        const resolvedPrice = customPrice ? customPrice.price : this.item.product[this.priceType];
        // Keep the stored price (typically 0) when no default price is available,
        // instead of overwriting it with null/undefined.
        if (resolvedPrice !== undefined && resolvedPrice !== null) {
          this.customPrice = customPrice ? customPrice.price : null;
          this.$set(this.item, 'unit_price', resolvedPrice);
        }
      }
      this.priceChange();
      if (this.item.product && this.item.product.name && this.isProductSelectFromStock) {
        this.fetchStock();
      }
    },
    onCountChange(count) {
      this.item.count = count;
      this.setNetPrice();
    },
    onUnitPriceChange(unitPrice) {
      this.$set(this.item, 'unit_price', Number.parseFloat(unitPrice));
      this.setNetPrice();
    },
    onPurchaseUnitPriceChange(unitPrice) {
      this.$set(this.item, 'purchase_unit_price', Number.parseFloat(unitPrice));
    },
    onNetPriceChange(price) {
      this.item.net_price = Number.parseFloat(price)
      this.item.unit_price = numberFormatter.round(Number.parseFloat(this.item.net_price) / parseInt(this.item.count))
      this.priceChange();
    },
    onVatChange(vat) {
      this.$set(this.item, 'vat', vat);
      this.priceChange();
    },
    onExpirationDateChange(expirationDate) {
      this.$set(this.item, 'expiration_date', expirationDate);
      if (expirationDate) {
        this.fieldsValidation.expirationDate = true;
      }
      this.loadBaseCount();
    },
    onSupplierChange(supplier) {
      const hasSupplier = supplier !== null && typeof supplier === 'object' && Object.keys(supplier).length > 0
      if (hasSupplier) {
        this.fieldsValidation.supplier = true;
        this.item.supplier = supplier
        this.item.supplier_id = supplier.id
        this.availableExpirationDates = supplier && supplier.expirations || [];
        this.loadBaseCount();
        this.$set(this.item, 'supplier', supplier);
      }

    },
    onCommentChange(comment) {
      this.$set(this.item, 'comment', comment);a
    },
    onDeclutterReasonChange(reason) {
      this.$set(this.item, 'declutter_reason', reason);
    },
    onRowDelete() {
      this.$set(this.item, 'deleted', true);
      this.priceChange();
    },
    setNetPrice() {
      this.item.net_price = Number.parseFloat(this.item.unit_price) * Number.parseInt(this.item.count) * Number.parseFloat(this.item.product_pack_type.count_per_pack)
      this.priceChange();
    },
    priceChange() {
      this.$emit('priceChange');
    },
    isElementDisabled(elementName) {
      return !this.enabledElements.includes(elementName);
    },
    isColumnDisplayed(column) {
      return this.enabledColumns.includes(column);
    },
    validateSupplier() {
      if (Object.keys(this.item.supplier).length < 1 && !this.item.deleted) {
        this.fieldsValidation.supplier = false;
      }
      return this.fieldsValidation.supplier;
    },
    validateExpirationDate() {
      if (!this.item.expiration_date && !this.item.deleted) {
        this.fieldsValidation.expirationDate = false;
      }
      return this.fieldsValidation.expirationDate;
    },
    async loadBaseCount() {
      if (this.item.expiration_date && this.item.supplier.id && this.item.product_pack_type && this.storageId && this.loadBaseCountFromStock) {
        this.baseCountLoading = true;
        this.item.base_count = await axios.get(`api/storages/${this.storageId}/pack-type/${this.item.product_pack_type.id}/supplier/${this.item.supplier.id}/expiration/${this.item.expiration_date}`);
        this.baseCountLoading = false;
      }
    },
  },
};
</script>
